import { createAction } from 'redux-actions'

const ns = 'companyAdmin/'

// Fetch company info
export const getCompanyInfo = createAction(`${ns}GET_COMPANY_INFO`)
export const getCompanyInfoSuccess = createAction(`${ns}GET_COMPANY_INFO_SUCCESS`)
export const getCompanyInfoFail = createAction(`${ns}GET_COMPANY_INFO_FAIL`)

// Update company info
export const updateCompanyInfo = createAction(`${ns}UPDATE_COMPANY_INFO`)
export const updateCompanyInfoSuccess = createAction(`${ns}UPDATE_COMPANY_INFO_SUCCESS`)
export const updateCompanyInfoFail = createAction(`${ns}UPDATE_COMPANY_INFO_FAIL`)

// Track selected company in company admin dropdown
export const setCompanyAdminSelectedCompanyId = createAction(`${ns}SET_COMPANY_ADMIN_SELECTED_COMPANY_ID`)
